"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _Theme = _interopRequireDefault(require("../common/Theme"));
var _iconsRemove = require("../resources/icons-remove.svg");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TextField = exports["default"] = /*#__PURE__*/function (_Component) {
  function TextField(props) {
    var _this;
    _classCallCheck(this, TextField);
    _this = _callSuper(this, TextField, [props]);
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      valid: null,
      focus: false
    };
    _this.inputRef2 = /*#__PURE__*/_react["default"].createRef();
    _this.autofilled = false;
    if (props.mimicField) {
      var field = document.getElementById(props.mimicField);
      if (field) {
        if (_this.props.detectAutoFill) {
          field.addEventListener("onautocomplete", function (e) {
            _this.onAutoFillStart(e);
          });
        }
      }
    }
    return _this;
  }
  _inherits(TextField, _Component);
  return _createClass(TextField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.forceBlur !== prevProps.forceBlur && this.props.forceBlur) this.forceBlur();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var detectAutoFill = this.props.detectAutoFill;
      if (detectAutoFill && this.inputRef2 && this.inputRef2.current) {
        this.inputRef2.current.addEventListener("onautocomplete", function (e) {
          if (e.target.hasAttribute("autocompleted")) _this2.onAutoFillStart(e);else _this2.onAutoFillCancel(e);
        });
      }
    }
  }, {
    key: "onAutoFillStart",
    value: function onAutoFillStart(e) {
      this.autofilled = true;
      this.onChange(e);
    }
  }, {
    key: "onAutoFillCancel",
    value: function onAutoFillCancel(e) {
      this.autofilled = false;
      this.onChange(e);
    }
  }, {
    key: "forceBlur",
    value: function forceBlur() {
      if (this.inputRef) this.inputRef.blur();
    }
  }, {
    key: "getInputRef",
    value: function getInputRef() {
      var _this$props = this.props,
        inputProps = _this$props.inputProps,
        inputRef = _this$props.inputRef;
      return inputProps && inputProps.ref && inputProps.ref.current ? inputProps.ref.current.node : inputRef ? inputRef : this.ref.current;
    }
  }, {
    key: "clearValue",
    value: function clearValue() {
      var _this$props2 = this.props,
        defaultValue = _this$props2.defaultValue,
        onClear = _this$props2.onClear;
      var inputRef = this.getInputRef();
      if (!inputRef) return;
      if (!this.props.select) {
        inputRef.value = "";
        var e = new Event("input", {
          bubbles: true,
          cancelable: true,
          target: inputRef
        });
        inputRef.dispatchEvent(e);
      } else if (this.props.onChange) {
        this.props.onChange({
          target: {
            value: defaultValue
          }
        });
      }
      inputRef.focus();
      if (onClear) onClear();
    }
  }, {
    key: "onInput",
    value: function onInput(e) {
      var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        validationMethod = _this$props3.validationMethod;
      var valid = this.state.valid;
      var inputRef = this.getInputRef();
      if (inputRef && inputRef.setAttribute) inputRef.setAttribute("size", e.target.value.length);
      if (onChange) onChange(e);
      if (validationMethod) {
        var newValid = validationMethod(e, e.target.value);
        if (newValid !== valid) this.setState({
          valid: newValid
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var onChange = this.props.onChange;
      if (onChange) onChange(e);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var onFocus = this.props.onFocus;
      this.setState({
        focus: true
      });
      if (onFocus) onFocus(e);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _this$props4 = this.props,
        onBlur = _this$props4.onBlur,
        validationMethod = _this$props4.validationMethod;
      var valid = this.state.valid;
      if (validationMethod) {
        var newValid = validationMethod(e, e.target.value);
        if (newValid !== valid) this.setState({
          valid: newValid,
          focus: false
        });
      } else this.setState({
        focus: false
      });
      if (onBlur) onBlur(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var onEnter = this.props.onEnter;
      if (onEnter && e.keyCode == 13) onEnter(e);
    }
  }, {
    key: "setInputRef",
    value: function setInputRef(inputRef) {
      if (inputRef) this.inputRef = inputRef;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        id = _this$props5.id,
        ref = _this$props5.ref,
        inputRef = _this$props5.inputRef,
        children = _this$props5.children,
        label = _this$props5.label,
        value = _this$props5.value,
        readOnly = _this$props5.readOnly,
        pattern = _this$props5.pattern,
        defaultValue = _this$props5.defaultValue,
        onClick = _this$props5.onClick,
        type = _this$props5.type,
        onEnter = _this$props5.onEnter,
        disabled = _this$props5.disabled,
        autoComplete = _this$props5.autoComplete,
        autoFocus = _this$props5.autoFocus,
        rows = _this$props5.rows,
        loading = _this$props5.loading,
        className = _this$props5.className,
        sx = _this$props5.sx,
        maxLength = _this$props5.maxLength,
        placeholder = _this$props5.placeholder,
        focusPlaceholder = _this$props5.focusPlaceholder,
        dense = _this$props5.dense,
        leadingIcon = _this$props5.leadingIcon,
        multiline = _this$props5.multiline,
        helperText = _this$props5.helperText,
        error = _this$props5.error,
        endAdornment = _this$props5.endAdornment,
        InputProps = _this$props5.InputProps,
        InputLabelProps = _this$props5.InputLabelProps,
        fullWidth = _this$props5.fullWidth,
        inputProps = _this$props5.inputProps,
        select = _this$props5.select,
        SelectProps = _this$props5.SelectProps,
        minRows = _this$props5.minRows,
        maxRows = _this$props5.maxRows,
        validationText = _this$props5.validationText,
        inputSx = _this$props5.inputSx;
      var clearable = this.props.clearable !== false && (select ? value !== defaultValue : value && value.length !== 0);
      var _this$state = this.state,
        valid = _this$state.valid,
        focus = _this$state.focus;
      return loading ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "klayo-textfield--loading"
      }, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
        width: 70,
        height: 20
      }), /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
        width: sx.width || null,
        height: 42
      })) : /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        id: id,
        ref: ref,
        inputRef: this.inputRef2,
        className: "klayo-textfield " + (dense ? " klayo-textfield-dense " : "") + (label ? " klayo-textfield-withlabel " : "") + (className ? className : "") + (this.autofilled ? " klayo-textfield--autofilled" : ""),
        label: label,
        variant: "outlined",
        select: select,
        SelectProps: SelectProps,
        placeholder: focusPlaceholder && focus ? focusPlaceholder : placeholder,
        multiline: multiline,
        rows: rows,
        minRows: minRows,
        maxRows: maxRows,
        onInput: this.onInput.bind(this),
        onChange: this.onChange.bind(this),
        onClick: onClick,
        onFocus: this.onFocus.bind(this),
        onKeyDown: this.onKeyDown.bind(this),
        onBlur: this.onBlur.bind(this),
        disabled: disabled,
        helperText: valid === false ? validationText : helperText,
        fullWidth: fullWidth,
        error: error || valid === false,
        InputLabelProps: _objectSpread({
          shrink: true,
          variant: "filled"
        }, InputLabelProps),
        autoComplete: typeof autoComplete === "string" ? autoComplete : autoComplete === false ? "off" : "on",
        autoFocus: autoFocus,
        value: value ? value : "",
        inputProps: _objectSpread({
          ref: inputRef ? inputRef : this.ref,
          maxLength: maxLength,
          pattern: pattern
        }, inputProps),
        InputProps: _objectSpread({
          notched: false,
          readOnly: readOnly,
          type: type,
          startAdornment: leadingIcon ? /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
            position: "start"
          }, leadingIcon) : null,
          endAdornment: endAdornment ? endAdornment : /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
            position: "end"
          }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
            className: "klayo-textfield_clearbutton",
            sx: {
              display: clearable ? "flex" : "none"
            },
            onClick: this.clearValue.bind(this)
          }, /*#__PURE__*/_react["default"].createElement(_iconsRemove.ReactComponent, null)))
        }, InputProps),
        sx: _objectSpread(_objectSpread({}, sx), {}, {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: _Theme["default"].getStyleVar("--neon-blue-nb-200")
            },
            "&:hover fieldset": {
              borderColor: _Theme["default"].getStyleVar("--neon-blue-nb-300")
            },
            "&.Mui-focused fieldset": {
              borderWidth: "2px",
              borderColor: _Theme["default"].getStyleVar("--neon-blue-nb-500")
            }
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: _Theme["default"].getStyleVar("--neon-blue-nb-500")
          }
        })
      }, children);
    }
  }]);
}(_react.Component);
_defineProperty(TextField, "defaultProps", {
  type: null,
  detectAutoFill: false,
  mimicField: null
});